import { toId } from '@/utils/id-helpers';

export const QUESTION_TYPES = {
  TEAM: 'team',
  PLAYER: 'player',
  PROP: 'prop',
  TIEBREAKER: 'tiebreaker',
} as const;

export type QuestionType = (typeof QUESTION_TYPES)[keyof typeof QUESTION_TYPES];

interface TeamData {
  team_id: string | number;
  [key: string]: unknown;
}

export function isTeamData(data: unknown): data is TeamData {
  return (
    typeof data === 'object' &&
    data !== null &&
    'team_id' in data &&
    (typeof (data as TeamData).team_id === 'string' ||
      typeof (data as TeamData).team_id === 'number')
  );
}

export function getTeamIdFromData(data: unknown): string | undefined {
  if (isTeamData(data)) {
    return toId(data.team_id);
  }

  return undefined;
}
